export interface PrintRadioConfig {
  title: string;
  name: string;
  valueKey: string;
  onChangeParams: string[];
  checkDisabled?: (receipt: any) => boolean;
}

export const PRINT_RADIO_CONFIGS: PrintRadioConfig[] = [
  {
    title: "타이틀",
    name: "printType1",
    valueKey: "title",
    onChangeParams: ["HEADER", "HALL", "title"],
  },
  {
    title: "채널주문번호",
    name: "printType2",
    valueKey: "channelNo",
    onChangeParams: ["HEADER", "HALL", "channelNo"],
  },
  {
    title: "포스주문번호",
    name: "printType3",
    valueKey: "posNo",
    onChangeParams: ["HEADER", "HALL", "posNo"],
    checkDisabled: receipt => receipt.posNo === "0",
  },
  {
    title: "도로명 주소",
    name: "printType4",
    valueKey: "loadAdr",
    onChangeParams: ["DELIVERY_ADDRESS", "HALL", "loadAdr"],
  },
  {
    title: "지번 주소",
    name: "printType5",
    valueKey: "adress",
    onChangeParams: ["DELIVERY_ADDRESS", "HALL", "adress"],
  },
  {
    title: "연락처",
    name: "printType6",
    valueKey: "phone",
    onChangeParams: ["TEL_NO", "HALL", "phone"],
  },
  {
    title: "요청사항",
    name: "printType7",
    valueKey: "memo",
    onChangeParams: ["REQ_MESSAGE", "HALL", "memo"],
  },
  {
    title: "메뉴",
    name: "printType8",
    valueKey: "menu",
    onChangeParams: ["MENU", "HALL", "menu"],
  },
  {
    title: "옵션",
    name: "printType9",
    valueKey: "option",
    onChangeParams: ["MENU", "HALL", "option"],
  },
  {
    title: "합계·결제방식",
    name: "printType10",
    valueKey: "payMethod",
    onChangeParams: ["TOTAL_AMOUNT", "HALL", "payMethod"],
  },
  {
    title: "매장명",
    name: "printType11",
    valueKey: "shopNm",
    onChangeParams: ["ORDER_INFO", "HALL", "shopNm"],
  },
  {
    title: "주문일시",
    name: "printType12",
    valueKey: "orderTime",
    onChangeParams: ["ORDER_INFO", "HALL", "orderTime"],
  },
];

export const KITCHEN_PRINT_RADIO_CONFIGS: PrintRadioConfig[] = [
  {
    title: "타이틀",
    name: "printType1_1",
    valueKey: "title",
    onChangeParams: ["HEADER", "KITCHEN"],
  },
  {
    title: "채널주문번호",
    name: "printType2_1",
    valueKey: "channelNo",
    onChangeParams: ["HEADER", "KITCHEN"],
  },
  {
    title: "포스주문번호",
    name: "printType3_1",
    valueKey: "posNo",
    onChangeParams: ["HEADER", "KITCHEN"],
    checkDisabled: receipt => receipt.posNo === "0",
  },
  {
    title: "요청사항",
    name: "printType4_1",
    valueKey: "memo",
    onChangeParams: ["REQ_MESSAGE", "KITCHEN"],
  },
  {
    title: "메뉴",
    name: "printType5_1",
    valueKey: "menu",
    onChangeParams: ["MENU", "KITCHEN"],
  },
  {
    title: "옵션",
    name: "printType6_1",
    valueKey: "option",
    onChangeParams: ["MENU", "KITCHEN"],
  },
  {
    title: "주문일시",
    name: "printType7_1",
    valueKey: "orderTime",
    onChangeParams: ["MENU", "KITCHEN"],
  },
];


